import React  from 'react';
import { IonModal, IonButton, IonLabel, IonIcon } from '@ionic/react';
import { _defaultButtonColor, _defaultPurpleButtonColor, _dict } from '../constants';
import { book, chatbubble, cloudUpload, list } from 'ionicons/icons';
import { useUIStore } from '../stateManagement/UIZustand';
import { useImportStore } from '../stateManagement/importZustand';
import { useHistory } from 'react-router';
import { useURLStore } from '../stateManagement/URLZustand';

interface ChoiceDialogProps {
  onClose: () => void;
  lang: string;
  onConfirm: () => void;
}

const ChoiceDialog: React.FC<ChoiceDialogProps> = ({ onClose, lang, onConfirm  }) => {
  const { isChoiceDialogOpen } = useUIStore();
  const { setImportMode } = useImportStore();
  const { getURLTo } = useURLStore();
  const history = useHistory();

  let modalStyle = {
      '--max-width': '100vh',//'300px',
      '--max-height': '80vh',//'500px'
      '--border-radius': '10px',
  }

  let buttonStyle = {
    //'--background': '#007ea7',
    fontSize:"20px",
    flexGrow: 1
  }



  return (
  <IonModal isOpen={isChoiceDialogOpen} style={modalStyle} onDidDismiss={() => {onClose()}}>
    <div className="ion-padding" style={{height:"100%", display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}>
      <IonButton expand="block" color="light" style={buttonStyle} onClick={() => {setImportMode("story"); onConfirm()} }>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
          <IonLabel>{_dict.storyMode[lang]}</IonLabel>
          <IonIcon icon={book} slot="end" size="large" />
        </div>
      </IonButton>
      <IonButton expand="block" color="light" style={buttonStyle} onClick={() => {setImportMode("flat"); onConfirm();}}>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
          <IonLabel>{_dict.listMode[lang]}</IonLabel>
          <IonIcon icon={list} slot="end" size='large'/>
        </div>
      </IonButton>
      <IonButton expand="block" color="light" style={buttonStyle} onClick={() => {setImportMode("tree"); onConfirm();}}>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
          <IonLabel>{_dict.talkMode[lang]}</IonLabel>
          <IonIcon icon={chatbubble} slot="end" size="large" />
        </div>
      </IonButton>
      <IonButton expand="block"  style={{ ...buttonStyle, color:"white", "--background": "#36454F"}}
      onClick={() => {history.push(getURLTo().drop())}}>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
          <IonLabel>{_dict.loadDotPecsFile[lang]}</IonLabel>
          <IonIcon icon={cloudUpload} slot="end" size="large" />
        </div>
      </IonButton>
      <IonButton expand="block" onClick={onClose} color="danger" style={{height:"60px", fontSize:"20px", width:"100%"}}>
          {_dict.dismissToast[lang]}
      </IonButton>
  </div>

</IonModal>

  );
};

export default ChoiceDialog;
